import type { HttpPort } from "~/lib/http";

export interface StudentMonsterDetails {
  id?: string;
  name: string;
  level: number;
  experience_points: number;
  body_color?: string | null;
  eye_type?: string | null;
  mouth_type?: string | null;
  accessory?: string | null;
}

export interface StudentMonsterSnapshot {
  monster: StudentMonsterDetails;
  xpForNextLevel: number | null;
  xpProgress: number;
}

export interface StudentProgressEntry {
  checkin_date: string;
  checkin_time?: string | null;
  checkout_time?: string | null;
  goal_1_rating?: number | null;
  goal_2_rating?: number | null;
  goal_3_rating?: number | null;
  mood?: number | null;
  xp_earned?: number | null;
  xp_total?: number | null;
}

export interface StudentProgressSnapshot {
  checkins: StudentProgressEntry[];
  streak: number;
  monster: Pick<StudentMonsterDetails, "level" | "experience_points"> | null;
}

const cleanName = (value: string) => value.trim();

export function createStudentJourneyModule(http: HttpPort, token: string) {
  return {
    loadMonster(classId: string): Promise<StudentMonsterSnapshot> {
      return http.request({ path: `/students/${classId}/monster`, token });
    },
    async renameMonster(classId: string, rawName: string): Promise<StudentMonsterDetails> {
      const name = cleanName(rawName);
      if (!name) throw new Error("Bitte einen Namen eingeben.");
      if (name.length > 30) throw new Error("Name zu lang (max. 30 Zeichen).");
      const value = await http.request<{ monster: StudentMonsterDetails }>({
        path: `/students/${classId}/monster`, method: "PUT", token, body: { name }
      });
      return value.monster;
    },
    loadProgress(classId: string): Promise<StudentProgressSnapshot> {
      return http.request({ path: `/students/${classId}/progress`, token });
    }
  };
}

export type StudentJourneyModule = ReturnType<typeof createStudentJourneyModule>;
